<template>
  <v-container>
    <v-content>
      <h1 class="text-center primary--text pt-4">
        Restlosplanung
      </h1>
    </v-content>
    <v-row cols="12">
      <v-col cols="12" sm="12">
        <PartialBatchesInformation></PartialBatchesInformation>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import PartialBatchesInformation from '../components/partialBatches/PartialBatchesInformation'

export default {
  components: {
    PartialBatchesInformation
  },
  data: () => ({
    content: {}
  }),
  created: function() {},
  methods: {}
}
</script>
